import { Type } from "@sinclair/typebox";

export const LoginProvider = Type.Union([
  Type.Literal("Salesforce"),
  Type.Literal("Microsoft Dynamics"),
  Type.Literal("Hubspot"),
  Type.Literal("google"),
  Type.Literal("saml"),
  Type.Literal("microsoft"),
]);

export type LoginProviderType = (typeof AppIds)[keyof typeof AppIds] | undefined;

export const AppIds = {
  SALESFORCE: "Salesforce",
  MICROSOFT_DYNAMICS: "Microsoft Dynamics",
  HUBSPOT: "Hubspot",
  GOOGLE: "google",
  SAML: "saml",
  MICROSOFT: "microsoft",
} as const;

export const CRMS = new Set<LoginProviderType>([AppIds.SALESFORCE, AppIds.MICROSOFT_DYNAMICS]);

export const isCrmLoginProviderWithTemplates = (loginProvider?: string): boolean => loginProvider === AppIds.SALESFORCE;
